// client/src/pages/Admin/ResourceManager/components/ResourceGrid.tsx
import React, { type FC, type MouseEvent } from 'react';
import type { Resource } from '../../../../shared/models/Resource';
import { ResourceCard } from './ResourceCard';

interface ResourceGridProps {
  resources: Resource[];
  selectedIds: Set<string>;
  onToggleSelection: (id: string) => void;
  onEdit: (resource: Resource) => void;
  onDelete: (id: string) => void;
  onStatusChange: (id: string, status: string) => void;
  onToggleActionMenu: (id: string, e: MouseEvent) => void;
  openActionMenu: string | null;
  getMatchFields: (resource: Resource) => string[];
  debouncedSearchTerm: string;
}

export const ResourceGrid: FC<ResourceGridProps> = ({
  resources,
  selectedIds,
  onToggleSelection,
  onEdit,
  onDelete,
  onStatusChange,
  onToggleActionMenu,
  openActionMenu,
  getMatchFields,
  debouncedSearchTerm
}) => {
  if (resources.length === 0) return null;

  return (
    <div className="resource-grid">
      {resources.map((resource) => {
        if (!resource._id) return null;

        return (
          <ResourceCard
            key={resource._id}
            resource={resource}
            isSelected={selectedIds.has(resource._id)}
            onToggleSelection={onToggleSelection}
            onEdit={onEdit}
            onDelete={onDelete}
            onStatusChange={onStatusChange}
            onToggleActionMenu={onToggleActionMenu}
            isActionMenuOpen={openActionMenu === resource._id}
            matchFields={getMatchFields(resource)}
            debouncedSearchTerm={debouncedSearchTerm}
          />
        );
      })}
    </div>
  );
};